import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from '@mui/material';
import { useTranslate } from 'react-admin';

interface LostMfaModalProps {
  open: boolean;
  onClose: () => void;
}

const LostMfaModal = ({ open, onClose }: LostMfaModalProps) => {
  const translate = useTranslate();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="lost-mfa-dialog-title"
    >
      <DialogTitle id="lost-mfa-dialog-title">
        {translate('action.lost_mfa_modal.title')}
      </DialogTitle>
      <DialogContent>
        <Typography paragraph>
          {translate('action.lost_mfa_modal.message')}
        </Typography>
        <Typography paragraph>
          <Link
            href="https://support-itmlimited.atlassian.net/servicedesk/customer/portals"
            target="_blank"
            rel="noopener noreferrer"
          >
            {translate('action.lost_mfa_modal.help_center_link')}
          </Link>
        </Typography>
        <Typography>
          <strong>{translate('action.lost_mfa_modal.phone')}</strong>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {translate('action.lost_mfa_modal.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LostMfaModal;

